module.exports = __webpack_public_path__ + "img/ban2.1d060dcb.jpg";